const OFFSET_RADIUS = {
  min: 0,
  max: 100,
  defaultValue: 50,
}

export { OFFSET_RADIUS }
